"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M1 1v22h22V1H1zm16.493 16.02h-3.757l-3.543-5.215v5.215H6.505V6.955h3.757l3.545 5.199V6.955h3.686V17.02z" }), "Naver");
//# sourceMappingURL=Naver.js.map